import { render, staticRenderFns } from "./CadastroEmpresa.vue?vue&type=template&id=07cfcf0d&scoped=true"
import script from "./CadastroEmpresa.vue?vue&type=script&lang=js"
export * from "./CadastroEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cfcf0d",
  null
  
)

export default component.exports